import { render } from "./WarningBox.vue?vue&type=template&id=7b7873e4&scoped=true"
import script from "./WarningBox.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./WarningBox.vue?vue&type=script&charset=utf-8&lang=js"

import "./WarningBox.vue?vue&type=style&index=0&id=7b7873e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7873e4"]])

export default __exports__